module.exports = __webpack_public_path__ + "media/images/category/feature/index/thum-aoj_c-1c1d92308c7b3e64c5738e61f595e146.jpg";